import React from "react";
import { Card, CardBody, CardHeader, Container, Row } from "reactstrap";

const TerminosYCondiciones = () => {
  React.useEffect(() => {
    document.body.classList.add("bg-default");
    return () => {
      document.body.classList.remove("bg-default");
    };
  }, []);

  return (
    <>
      <div className="main-content">
        <div className="header bg-gradient-warning py-7 py-lg-8">
          <div className="separator separator-bottom separator-skew zindex-100">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              preserveAspectRatio="none"
              version="1.1"
              viewBox="0 0 2560 100"
              x="0"
              y="0"
            >
              <polygon
                className="fill-default"
                points="2560 0 2560 100 0 100"
              />
            </svg>
          </div>
        </div>

        <Container className="mt--8 pb-5">
          <Row className="justify-content-center">
            <Card>
              <CardHeader>
                <h1>T&Eacute;RMINOS Y CONDICIONES DE USO</h1>
              </CardHeader>

              <CardBody>
                <p>
                  <strong>CONTRATO DE LICENCIA DE USO DE SOFTWARE PARA USUARIO FINAL</strong>
                </p>

                <p>
                  MUY IMPORTANTE: POR FAVOR, LEA EL PRESENTE DOCUMENTO ANTES DE ACEPTAR Y/O USAR LA APLICACI&Oacute;N.
                </p>

                <p>
                  MAINPRO CONSULTORS, SLU, con C.I.F. B-61924593, domicilio social en Cam&iacute; de la Seu, 7, 25700
                  La Seu d&apos;Urgell (en adelante, el &quot;LICENCIANTE&quot; o &quot;MAINPRO&quot;), y de la otra el usuario de la
                  aplicaci&oacute;n (en adelante &quot;LICENCIATARIO&quot; o &quot;CLIENTE&quot;).
                </p>

                <p><strong>MANIFIESTAN</strong></p>
                <ol type="I">
                  <li>
                    Que MAINPRO es el desarrollador y &uacute;nico titular de todos los derechos de propiedad intelectual e
                    industrial sobre la aplicaci&oacute;n inform&aacute;tica de registro horario denominada &quot;Flexihora&quot;
                    (en adelante, el &quot;Software&quot;o &ldquo;Aplicaci&oacute;n&rdquo;), la cual se ofrece como un servicio
                    alojado en los servidores del LICENCIANTE (Software as a Service - SaaS) y accesibles a trav&eacute;s de
                    los dominios https://mainpro.info y https://flexihora.com. Y del cual se excluye cualquier otro uso del
                    que se defina en los documentos de ayuda del software.
                  </li>
                  <li>
                    Que el CLIENTE est&aacute; interesado en adquirir una licencia de uso del Software para la gesti&oacute;n del
                    registro horario de sus empleados, de acuerdo con sus necesidades empresariales y la normativa vigente.
                  </li>
                  <li>
                    Que las partes han acordado formalizar el presente Contrato de Licencia de Uso con sujeci&oacute;n a las
                    siguientes,
                  </li>
                  <li>
                    Que la Aplicaci&oacute;n que se pone a disposici&oacute;n del LICENCIATARIO para su uso, es compatible:
                    <ul style={{ marginTop: "20px", marginBottom: "20px" }}>
                      <li>
                        Con los siguientes sistemas operativos:
                        <ul>
                          <li>Windows</li>
                          <li>Mac OS</li>
                          <li>GNU/Linux</li>
                          <li>Android</li>
                        </ul>
                      </li>
                      <li>
                        Con los siguientes navegadores:
                        <ul>
                          <li>Google Chrome</li>
                          <li>Mozilla Firefox</li>
                          <li>Edge</li>
                          <li>Safari</li>
                        </ul>
                      </li>
                    </ul>
                  </li>
                </ol>

                <p><strong>CL&Aacute;USULAS</strong></p>

                <ol>
                  <li><strong>PRIMERA.- OBJETO DEL CONTRATO</strong></li>
                </ol>
                <p>
                  Mediante el presente Contrato, el LICENCIANTE concede al LICENCIATARIO una licencia no exclusiva,
                  intransferible y revocable para acceder y utilizar el Software &quot;Flexihora&quot; a trav&eacute;s de internet,
                  para los fines internos de su negocio y durante la vigencia del presente Contrato.
                </p>
                <p>
                  El acceso al Software se realizar&aacute; mediante las credenciales (usuario y contrase&ntilde;a) que ser&aacute;n
                  proporcionadas al CLIENTE a trav&eacute;s del distribuidor o revendedor autorizado por MAINPRO.
                </p>

                <ol start="2">
                  <li><strong>SEGUNDA.- DURACI&Oacute;N</strong></li>
                </ol>
                <p>
                  El presente Contrato tendr&aacute; una duraci&oacute;n mensual, renov&aacute;ndose autom&aacute;ticamente por
                  per&iacute;odos iguales y sucesivos, salvo que alguna de las partes notifique a la otra su voluntad de no
                  renovarlo con una antelaci&oacute;n m&iacute;nima de quince (15) d&iacute;as naturales a la fecha de vencimiento
                  del per&iacute;odo en curso.
                </p>

                <ol start="3">
                  <li><strong>TERCERA.- CONDICIONES ECON&Oacute;MICAS</strong></li>
                </ol>
                <ol>
                  <li>
                    Como contraprestaci&oacute;n por la licencia de uso, el CLIENTE abonar&aacute; una cuota mensual cuyo
                    importe se calcular&aacute; en funci&oacute;n del n&uacute;mero de empleados dados de alta en la
                    aplicaci&oacute;n que requieran acceso a la misma.
                  </li>
                  <li>
                    El precio y las condiciones de pago ser&aacute;n los establecidos en la oferta comercial presentada por el
                    distribuidor o revendedor autorizado a trav&eacute;s del cual el CLIENTE ha contratado el servicio.
                  </li>
                  <li>
                    El pago de las cuotas se realizar&aacute; directamente al distribuidor o revendedor autorizado. El impago
                    de cualquier cuota facultar&aacute; al LICENCIANTE para suspender temporalmente el acceso al Software
                    hasta la regularizaci&oacute;n del pago, sin perjuicio de su derecho a resolver el Contrato seg&uacute;n
                    lo estipulado en la cl&aacute;usula d&eacute;cima.
                  </li>
                </ol>

                <ol start="4">
                  <li><strong>CUARTA.- OBLIGACIONES DEL LICENCIANTE</strong></li>
                </ol>
                <p>El LICENCIANTE se compromete a:</p>
                <ol>
                  <li>
                     Mantener el Software operativo y accesible, salvo interrupciones por mantenimiento programado o causas
                    de fuerza mayor.
                  </li>
                  <li>
                     Prestar el servicio de soporte t&eacute;cnico postventa para resolver incidencias relacionadas con el
                    funcionamiento del Software.
                  </li>
                  <li>
                     Realizar las actualizaciones y mejoras del Software que considere oportunas para garantizar su correcto
                    funcionamiento y adaptaci&oacute;n a la normativa.
                  </li>
                  <li>
                     Adoptar las medidas de seguridad necesarias para proteger la integridad y confidencialidad de los datos
                    alojados en sus servidores.
                  </li>
                </ol>

                <ol start="5">
                  <li><strong>QUINTA.- OBLIGACIONES Y PROHIBICIONES DEL LICENCIATARIO</strong></li>
                </ol>
                <p>El LICENCIATARIO se compromete a:</p>
                <ol>
                  <li>
                     Utilizar el Software de acuerdo con su finalidad, en acuerdo a la legislaci&oacute;n vigente y los
                    t&eacute;rminos de este Contrato.
                  </li>
                  <li>
                     Abonar puntualmente las cuotas de la licencia al distribuidor o revendedor correspondiente.
                  </li>
                  <li>
                     Custodiar diligentemente sus credenciales de acceso, siendo el &uacute;nico responsable del uso que se
                    haga de las mismas.
                  </li>
                  <li>
                     No realizar actos de ingenier&iacute;a inversa, descompilaci&oacute;n, desensamblaje o cualquier otra
                    acci&oacute;n que pretenda descubrir el c&oacute;digo fuente del Software.
                  </li>
                  <li>
                     No ceder, sublicenciar, alquilar, vender o transferir de cualquier modo los derechos de uso otorgados
                    en este Contrato a terceros.
                  </li>
                  <li>
                  No utilizar el Software para fines il&iacute;citos o que puedan perjudicar los derechos del LICENCIANTE
                    o de terceros.
                  </li>
                </ol>

                <p>Asimismo, corresponde al CLIENTE:</p>
                <ol>
                  <li>
                    Usar diligentemente los datos asociados a su Cuenta de Flexihora, as&iacute; como de sus C&oacute;digos de
                    Usuario y contrase&ntilde;as de acceso a la APLICACI&Oacute;N.
                  </li>
                  <li>
                    Mantener el secreto y confidencialidad de las mismas, no ceder su uso a terceros, ya sea temporal o
                    permanente, ni a permitir su acceso a personas ajenas.
                  </li>
                  <li>
                    Comunicar de forma inmediata a MAINPRO la p&eacute;rdida, robo, extrav&iacute;o, acceso no autorizado o
                    infracci&oacute;n de seguridad de las claves de acceso en el menor plazo de tiempo posible. Mientras no se
                    comuniquen tales hechos, MAINPRO quedar&aacute; eximido de cualquier responsabilidad que pudiera derivarse
                    del uso indebido de los identificadores o contrase&ntilde;as por terceros no autorizados.
                  </li>
                  <li>
                    Responder de las actividades que se realicen mediante el uso de la clave de acceso. De conformidad con lo
                    dispuesto en la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Informaci&oacute;n y de
                    Comercio Electr&oacute;nico (en adelante LSSI) y en la medida de lo que sea aplicable al contrato entre
                    MAINPRO y EL CLIENTE.
                  </li>
                  <li>
                    El CLIENTE reconoce y acepta que MAINPRO no controla la utilizaci&oacute;n que EL CLIENTE hace de la
                    APLICACI&Oacute;N ni tiene conocimiento efectivo sobre si la actividad o los datos o la informaci&oacute;n que
                    env&iacute;a para su procesamiento por la misma,. es l&iacute;cita y no lesiona bienes ni derechos de un
                    tercero. A estos efectos EL CLIENTE declara y garantiza que los datos y la informaci&oacute;n son de su
                    propiedad o que dispone de una autorizaci&oacute;n o licencia que le permite tratar los mismos.
                  </li>
                </ol>

                <p>
                  Por ello la responsabilidad sobre esa informaci&oacute;n y sobre las actividades llevadas a cabo son
                  exclusivamente del CLIENTE, que exime a MAINPRO de cualquier responsabilidad que tenga origen en dicha
                  informaci&oacute;n o con la actividad relacionada con su procesamiento por la APLICACI&Oacute;N y el
                  almacenamiento temporal y transitorio en los servidores del proveedor de MAINPRO. Asimismo, EL CLIENTE conoce
                  que el almacenamiento de los datos se ubica en un Data Center en el Espacio Econ&oacute;mico Europeo.
                </p>

                <p>
                  MAINPRO no ser&aacute; en ning&uacute;n caso responsable, ni ante el CLIENTE ni ante terceros, por: (i) los
                  fallos y vulnerabilidades registrados en el sistema de autenticaci&oacute;n del CLIENTE; (ii) los fallos que se
                  produzcan durante la autenticaci&oacute;n y el acceso a la APLICACI&Oacute;N a trav&eacute;s del servicio de
                  autenticaci&oacute;n del CLIENTE (incluyendo una posible denegaci&oacute;n de acceso); (iii) el acceso a la
                  APLICACI&Oacute;N, a trav&eacute;s del servicio de autenticaci&oacute;n federada del CLIENTE, de terceros no
                  autorizados por el CLIENTE, de cuyas acciones responder&aacute; el CLIENTE.
                </p>

                <ol start="6">
                  <li><strong>SEXTA.- PROPIEDAD INTELECTUAL E INDUSTRIAL</strong></li>
                </ol>
                <p>
                  El presente Contrato no implica la cesi&oacute;n de ning&uacute;n derecho de propiedad intelectual o
                  industrial sobre el Software. MAINPRO retiene la titularidad exclusiva de todos los derechos de autor,
                  marcas, patentes, explotaci&oacute;n y cualquier otro derecho asociado a &quot;Flexihora&quot;. El CLIENTE
                  &uacute;nicamente adquiere un derecho de uso limitado en los t&eacute;rminos aqu&iacute; establecidos.
                </p>
                <p>
                  Los derechos de propiedad intelectual e industrial sobre la APLIACION son titularidad de MAINPRO,
                  correspondi&eacute;ndole el ejercicio exclusivo de los derechos de explotaci&oacute;n de los mismos en cualquier
                  forma y, en especial, los derechos de reproducci&oacute;n, distribuci&oacute;n, comunicaci&oacute;n p&uacute;blica
                  y transformaci&oacute;n.
                </p>
                <p>
                  Los terceros titulares de derechos de propiedad intelectual e industrial sobre fotograf&iacute;as, logotipos, y
                  cualesquiera otros s&iacute;mbolos o contenidos incluidos en la APLICACION han concedido las correspondientes
                  autorizaciones para su reproducci&oacute;n, distribuci&oacute;n y puesta a disposici&oacute;n del p&uacute;blico.
                </p>
                <p>
                  En ning&uacute;n caso, el uso de esta licencia permite la copia, modificaci&oacute;n y/o conexi&oacute;n con otras
                  aplicaciones o sistemas del Software sin el consentimiento expreso y firmado por parte de MAINPRO.
                </p>

                <ol start="7">
                  <li><strong>S&Eacute;PTIMA.- PROTECCI&Oacute;N DE DATOS</strong></li>
                </ol>
                <p>
                  De trabajadores del LICENCIANTE
                </p>
                <p>
                  El cumplimiento de las obligaciones legales en el punto 1 letra a) de estos t&eacute;rminos y condiciones de
                  uso, puede exigir la comunicaci&oacute;n de datos personales de los trabajadores del LICENCIANTARIO al
                  LICENCIANTE, pues la responsabilidad solidaria puede alcanzar al LICENCIANTE.
                </p>
                <p>
                  Asimismo, Y DEBIDO A OBLIGACIONES LEGALES, EL LICENCIANTE puede verse obligado a transferir la
                  informaci&oacute;n del LICENCIANCIATARIO a administraciones p&uacute;blicas por cumplimiento de obligaciones
                  legales.
                </p>
                <p>
                  MAINPRO como Responsable del tratamiento le informa de que tratar&aacute; sus datos personales de conformidad
                  con lo dispuesto en el Reglamento (UE) 2016/679, de 27 de abril (GDPR), y la Ley Org&aacute;nica 3/2018, de 5
                  de diciembre (LOPDGDD), para lo que le facilitamos la siguiente informaci&oacute;n sobre el mismo:
                </p>
                <p>
                  Fines y legitimaci&oacute;n del tratamiento: trataremos sus datos personales para: Crear y gestionar su cuenta
                  de usuario en la plataforma, la base leg&iacute;tima es su consentimiento (art. 6.1.a GDPR).
                </p>
                <p>
                  Coordinar las actividades empresariales y evitar responsabilidades por incumplimiento como CONTRATISTA en
                  materia de Registro de jornada Laboral, por ser necesario para el cumplimiento de sus obligaciones legales
                  (art. 6.1.c GDPR).
                </p>
                <p>
                  Su localizaci&oacute;n, nunca se usara para entablar una relaci&oacute;n con usted como persona f&iacute;sica,
                  por ser necesario para la satisfacci&oacute;n de nuestros intereses leg&iacute;timos (art. 6.1.f GDPR).
                </p>
                <p>
                  Puede obtener informaci&oacute;n adicional sobe el tratamiento en
                  <a href="https://mainpro.info/Privacidad" target="_blank" rel="noreferrer"> https://mainpro.info/Privacidad</a>
                </p>
                <p>
                  Criterios de conservaci&oacute;n de los datos: se conservar&aacute;n durante no m&aacute;s tiempo del necesario
                  para los fines del tratamiento o mientras existan prescripciones legales que dictaminen su custodia y cuando
                  ya no sea necesario para ello, se destruir&aacute;n con medidas de Seguridad adecuadas para garantizar su
                  anonimizaci&oacute;n o destrucci&oacute;n total.
                </p>
                <p>
                  Comunicaci&oacute;n de los datos: no se ceder&aacute;n datos a terceros, salvo obligaci&oacute;n legal.
                </p>
                <p>
                  Derechos que puede ejercer: de acceso, rectificaci&oacute;n, portabilidad y supresi&oacute;n de sus datos y de
                  limitaci&oacute;n u oposici&oacute;n a su tratamiento; a presentar una reclamaci&oacute;n ante la Autoridad de
                  control (
                  <a href="https://www.aepd.es" target="_blank" rel="noreferrer">www.aepd.es</a>) si considera que el
                  tratamiento no se ajusta a la normativa vigente, y a revocar el consentimiento prestado para la creaci&oacute;n
                  de su cuenta de usuario en cualquier momento. Puede ejercer sus derechos ante:
                </p>
                <p>
                  Mainpro Consultors, slu Av. Pau Claris, 44 &ndash; 25700 La Seu d&apos;Urgell (Lleida). E-mail:
                  <a href="mailto:gestoria@estanol.com"> gestoria@estanol.com</a> Datos de contacto del delegado de
                  protecci&oacute;n de datos: AV PAU CLARIS N&Uacute;M 44 &ndash;
                  <a href="mailto:dpo@mainprosl.com"> dpo@mainprosl.com</a>
                </p>
                <p>
                  En los t&eacute;rminos y alcance previsto en la normativa legal vigente, ambas Partes se obligan a guardar
                  secreto y mantener la m&aacute;s estricta confidencialidad de toda la Informaci&oacute;n Confidencial propiedad
                  de la otra Parte a la que tengan acceso como consecuencia de la prestaci&oacute;n de los Servicios objeto de
                  estas Condiciones. No obstante, lo anterior, MAINPRO podr&aacute;, con la finalidad de realizar an&aacute;lisis
                  internos y estudios estad&iacute;sticos, as&iacute; como para mejorar las funcionalidades de la APLICACI&Oacute;N
                  y garantizar un servicio adecuado para el CLIENTE, utilizar y transmitir, de manera agregada y/o anonimizada,
                  la informaci&oacute;n que el CLIENTE introduzca o guarde en la APLICACI&Oacute;N, sin que ello suponga una
                  vulneraci&oacute;n de la presente Cl&aacute;usula de Confidencialidad.
                </p>
                <p>
                  Ser&aacute; considerado como Informaci&oacute;n Confidencial a los efectos de las presentes Condiciones todo el
                  know-how o saber hacer de cada una de las Partes, entendi&eacute;ndose por tal, sin que el siguiente listado
                  tenga car&aacute;cter limitativo, todos los aspectos relacionados con conocimientos &uacute;tiles de cada una de
                  las Partes o de cualquier empresa del Grupo al que pertenezcan, que permitan a dicha Parte tener ventajas
                  competitivas en el mercado y que tienen car&aacute;cter industrial, tecnol&oacute;gico y/o comercial. En
                  particular, cualesquiera aspectos relacionados con el desarrollo o perfeccionamiento tecnol&oacute;gico ya
                  patentado o susceptible de serlo, conocimientos adquiridos por la otra Parte en particular para la correcta
                  ejecuci&oacute;n del objeto de las Condiciones, y cuantos datos de tipo t&eacute;cnico o comercial tenga a su
                  disposici&oacute;n la otra Parte relativos a la ejecuci&oacute;n del objeto de las Condiciones, incluyendo en
                  particular todos los conocimientos que pueden proporcionarle una ventaja competitiva en el mercado, abarcando
                  tanto los conocimientos tecnol&oacute;gicos como los industriales y los comerciales.
                </p>
                <p>
                  La obligaci&oacute;n de confidencialidad permanecer&aacute; vigente durante la validez de estas Condiciones y
                  sobrevivir&aacute; por tiempo indefinido a la terminaci&oacute;n o expiraci&oacute;n de estas Condiciones por
                  cualquier causa.
                </p>
                <p>
                  Las restricciones relativas al uso, reproducci&oacute;n, transmisi&oacute;n o acceso a la Informaci&oacute;n
                  Confidencial no ser&aacute;n de aplicaci&oacute;n en los casos en que dicha informaci&oacute;n:
                </p>
                <ol>
                  <li>
                    Fuera de dominio p&uacute;blico antes de la fecha de las presentes Condiciones o deviniese accesible
                    p&uacute;blicamente en publicaci&oacute;n impresa o en publicaciones de general circulaci&oacute;n, sin que en
                    dicha circunstancia hubiese intervenido incumplimiento alguno de la Parte receptora.
                  </li>
                  <li>
                    Deba ser obligatoriamente facilitada en virtud de obligaci&oacute;n legal o por resoluci&oacute;n
                    v&aacute;lidamente emitida por cualquier autoridad administrativamente competente, tribunal u &oacute;rgano
                    jurisdiccional, legalmente facultado para obligar a tal disponibilidad, &uacute;nicamente en cuanto a la
                    informaci&oacute;n que deba ser facilitada, siempre y cuando la Parte receptora as&iacute; requerida notifique
                    inmediatamente a la Parte reveladora de la recepci&oacute;n de tal requerimiento, a fin de que la Parte
                    reveladora pueda evaluar si existe posibilidad de eludir el mismo o pueda prestar cualquier apoyo
                    razonablemente solicitado por la Parte receptora.
                  </li>
                </ol>
                <p>
                  Nota sobre los contratos de la cl&aacute;usula de confidencialidad: MAINPRO facilita en la aplicaci&oacute;n,
                  una cl&aacute;usula de confidencialidad e informativa para los empleados que puede ser v&aacute;lida e muchas
                  ocasiones de tratamientos de bajo riesgo, no obstante, puede no ser v&aacute;lida en muchas otras ocasiones,
                  corresponde al CLIENTE como responsable del tratamiento, validar si dichas cl&aacute;usulas son v&aacute;lidas en
                  su organizaci&oacute;n en ning&uacute;n caso se responsabilizar&aacute; a MAINPRO de las consecuencias que
                  pudieran derivarse por el incumplimiento de este punto.
                </p>
                <p>
                  En caso de que el CLIENTE fuera conocedor de alguna brecha o violaci&oacute;n de seguridad que pudiera afectar a
                  la APLICACI&Oacute;N, este lo pondr&aacute; en conocimiento a MAINPRO sin dilaci&oacute;n y en cualquier caso,
                  antes de 48 horas a trav&eacute;s del correo
                  <a href="mailto:dpd@mainprosl.com"> dpd@mainprosl.com</a>.
                </p>

                <ol start="8">
                  <li><strong>OCTAVA.- LIMITACI&Oacute;N DE RESPONSABILIDAD</strong></li>
                </ol>
                <p>
                  La responsabilidad total del LICENCIANTE por cualquier reclamaci&oacute;n derivada del presente Contrato se
                  limitar&aacute;, en cualquier caso, al importe total de las cuotas abonadas por el CLIENTE en los seis (6)
                  meses inmediatamente anteriores a la fecha en que se produjo el hecho causante de la reclamaci&oacute;n.
                </p>
                <p>
                  El LICENCIANTE no ser&aacute; responsable de da&ntilde;os indirectos, lucro cesante, p&eacute;rdida de datos o de
                  oportunidades de negocio que pueda sufrir el CLIENTE.
                </p>
                <p>
                  EL LICENCIANTE cuenta con una pol&iacute;tica de copias de seguridad que gestiona con su proveedor de
                  Servicios de hosting. La frecuencia de las copias de seguridad, y su periodo de retenci&oacute;n podr&aacute;
                  variar seg&uacute;n la modalidad de servicio contratado.
                </p>
                <p>
                  A pesar de aplicar el sistema de calidad, la APLICACI&Oacute;N puede verse sometida a circunstancias aleatorias
                  que reduzcan su funcionamiento; entre otras de hardware y otros programas (software) instalados en el mismo
                  dispositivo donde se utiliza el Software, as&iacute; como de errores de c&aacute;lculo u otros errores de
                  imposible detecci&oacute;n en condiciones normales de simulaci&oacute;n u otros errores los cuales, a pesar de
                  aplicar el sistema de calidad, el Software puede verse sometido a circunstancias aleatorias que reduzcan su
                  funcionamiento; entre otras de hardware y otros programas instalados en el mismo dispositivo donde se utiliza
                  el software as&iacute; como de errores de c&aacute;lculo u otros errores de imposible detecci&oacute;n en
                  condiciones normales de simulaci&oacute;n.
                </p>
                <p>
                  Los posibles fallos en el Software tambi&eacute;n pueden tener su origen en el elevado n&uacute;mero de casos
                  y/o concurrencia de accesos que pueden producirse y la necesidad del CLIENTE de utilizar los programas de
                  forma inmediata, de manera que no exista un lapso de tiempo suficiente entre las peticiones y el procesado
                  de estas.
                </p>
                <p>
                  El Licenciante no ser&aacute; responsable de los errores de funcionamiento ni da&ntilde;os provocados por el
                  incumplimiento de las obligaciones propias de todo usuario o por los causados por manipulaciones de personal
                  no autorizado, inexperto, o mal intencionado.
                </p>
                <p>
                  El Licenciante dar&aacute; respuesta a las incidencias de las que tenga conocimiento sin dilaci&oacute;n y, en
                  cualquier caso, en un plazo no superior a treinta (30) d&iacute;as naturales salvo que sea imposible o de una
                  complejidad muy elevada dar respuesta en este periodo, en cuyo caso, comunicar&aacute; al CLIENTE tal
                  situaci&oacute;n a la mayor brevedad posible con la m&aacute;xima informaci&oacute;n y los motivos que causen
                  dicha demora.
                </p>
                <p>
                  El Licenciante no quedar&aacute; vinculado por los compromisos o promesas realizados por personas ajenas a su
                  empresa, ni por expectativas err&oacute;neas con respecto a la funcionalidad del programa.
                </p>
                <p>
                  MAINPRO se reserva el derecho de editar, actualizar, modificar, suspender, eliminar o finalizar las funciones
                  ofrecidas por la APLICACION, incluyendo todo o parte de su contenido, sin necesidad de previo aviso, as&iacute;
                  como de modificar la forma o tipo de acceso a esta.
                </p>
                <p>
                  Las posibles causas de modificaci&oacute;n pueden tener lugar por motivos tales como su adaptaci&oacute;n a las
                  posibles novedades legislativas y cambios en la propia APLICACION, as&iacute; como a las que se puedan derivar
                  de los c&oacute;digos tipos existentes en la materia o por motivos estrat&eacute;gicos o corporativos.
                </p>
                <p>
                  MAINPRO no ser&aacute; responsable del uso de la APLICACION por otra persona distinta al LICENCIANTE, siendo
                  el uso de la misma exclusiva responsabilidad de este &uacute;ltimo.
                </p>
                <p>
                  La APLICACION se facilita &laquo;tal y como es&raquo;. MAINPRO no se hace responsable de que esta sirva y
                  cumpla con todos sus objetivos. No obstante lo anterior, MAINPRO se compromete en la medida de sus
                  posibilidades a contribuir en la mejora de la calidad de la APLICACION, pero no puede garantizar la
                  precisi&oacute;n ni la actualidad del contenido de la misma.
                </p>
                <p>
                  La responsabilidad de uso de la APLICACION corresponde solo al CLIENTE. Salvo lo establecido en estos
                  T&eacute;rminos y Condiciones, MAINPRO, no es responsable de ninguna p&eacute;rdida o da&ntilde;o que se
                  produzca en relaci&oacute;n con el uso de la APLICACION, tales como los producidos a consecuencia de fallos,
                  aver&iacute;as o bloqueos en el funcionamiento de la APLICACION (por ejemplo, y sin car&aacute;cter limitativo:
                  error en las l&iacute;neas de comunicaciones, defectos en el hardware o fallos en la red de Internet).
                  Igualmente, MAINPRO, tampoco ser&aacute; responsable de los da&ntilde;os producidos a consecuencia de un uso
                  indebido o inadecuado de la APLICACION por parte del CLIENTE.
                </p>

                <ol start="9">
                  <li><strong>NOVENA.- RESOLUCI&Oacute;N DEL CONTRATO</strong></li>
                </ol>
                <p>
                  El presente Contrato podr&aacute; ser resuelto por las siguientes causas:
                </p>
                <ol>
                  <li> Por mutuo acuerdo de las partes.</li>
                  <li>
                     Por la decisi&oacute;n de cualquiera de las partes, comunicada con el preaviso establecido en la
                    cl&aacute;usula segunda.
                  </li>
                  <li>
                     Por incumplimiento grave de cualquiera de las obligaciones estipuladas. Se considerar&aacute;
                    incumplimiento grave, entre otros, el impago de las cuotas, la violaci&oacute;n de los derechos de
                    propiedad intelectual o el uso fraudulento del Software.
                  </li>
                </ol>
                <p>
                  En caso de resoluci&oacute;n, el acceso del CLIENTE al Software ser&aacute; cancelado. El LICENCIANTE
                  mantendr&aacute; los datos del CLIENTE a su disposici&oacute;n para su exportaci&oacute;n durante un plazo de
                  treinta (30) d&iacute;as naturales, tras los cuales ser&aacute;n eliminados de forma segura.
                </p>
                <p>
                  Este contrato quedar&aacute; siempre publicado estar&aacute; accesible en todo momento a disposici&oacute;n del
                  CLIENTE en el dominio
                  <a href="https://mainpro.info/Contrato_licencia" target="_blank" rel="noreferrer"> https://mainpro.info/Contrato_licencia</a>
                </p>

                <ol start="10">
                  <li><strong>D&Eacute;CIMA.- LEY APLICABLE Y JURISDICCI&Oacute;N</strong></li>
                </ol>
                <p>
                  El presente Contrato tiene car&aacute;cter mercantil y se regir&aacute; e interpretar&aacute; de acuerdo con
                  la legislaci&oacute;n espa&ntilde;ola.
                </p>
                <p>
                  Para la resoluci&oacute;n de cualquier controversia que pudiera surgir en relaci&oacute;n con la
                  interpretaci&oacute;n o ejecuci&oacute;n del presente Contrato, las partes se someten expresamente a la
                  jurisdicci&oacute;n de los Juzgados y Tribunales de la ciudad de La Seu d&apos;Urgell, con renuncia a
                  cualquier otro fuero que pudiera corresponderles.
                </p>
                <p>
                  La consideraci&oacute;n de nulidad de cualquier cl&aacute;usula de este contrato no representar&aacute; en
                  ning&uacute;n caso la nulidad del resto del contrato.
                </p>
                <p>Versi&oacute;n 2.1 actualizada a 9 de febrero de 2026</p>
              </CardBody>
            </Card>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default TerminosYCondiciones;
